// extracted by mini-css-extract-plugin
export default {"header":"ReusableAuth_header__36VVI","closeButtonSvg":"ReusableAuth_closeButtonSvg__TTM2a","hidden":"ReusableAuth_hidden__CBHdU"};